<app-breadcrumb [title]="'Listado'" [items]="['Mantenimiento']" [active_item]="'Listado'">
</app-breadcrumb>

<div class="card">
  <div class="card-header d-flex align-items-center bg-primary text-white">
    <i class="icofont icofont-verification-check me-2"></i>
    <h5 class="mb-0"><strong>CONSULTA DE MANTENIMIENTOS</strong></h5>
  </div>

  <div class="card-body">
    <form [formGroup]="formMantenimiento">
      <div class="row g-3">
        <div class="col-md-4">
          <label class="form-label" for="vehiculos"><strong>Placa</strong> *:</label>
          <ng-select id="vehiculos"
            [items]="vehiculos"
            bindLabel="placa" 
            bindValue="placa" 
            formControlName="placa"
            [multiple]="true"
            placeholder="Selecciona una opción" class="js-example-placeholder-multiple">
          </ng-select>
        </div>

        <div class="col-md-4">
          <label class="form-label" for="fecha"><strong>Fecha Inicial</strong> *:</label>
          <div class="input-group input-group-sm">
            <input id="fecha" type="date" formControlName="fecha" class="form-control form-control-lg fs-14"
              name="fecha" (change)="actualizarMinFechaFinal()" [max]="hoy" onkeydown="return false;" />
          </div>
        </div>

        <div class="col-md-4">
          <label class="form-label" for="fechaFinal"><strong>Fecha de Finalización</strong> *:</label>
          <div class="input-group input-group-sm">
            <input id="fechaFinal" type="date" formControlName="fechaFinal" class="form-control form-control-lg fs-14"
              name="fechaFinal" [min]="minFechaFinal" [max]="hoy" onkeydown="return false;"/>
          </div>
        </div>

      </div>
      <div class="card card-absolute border border-primary rounded my-5">
        <div class="card-header bg-primary">
          <h5 class="text-white"><strong>FILTROS RÁPIDOS</strong></h5>
        </div>
        <div class="card-body">
          <div class="row g-3 mb-3">
            <div class="col-md-2">
              <button type="button" class="btn btn-outline-primary btn-sm w-100"
                (click)="seleccionarRango('dia')"><strong>AYER</strong></button>
            </div>
            <div class="col-md-2">
              <button type="button" class="btn btn-outline-primary btn-sm w-100"
                (click)="seleccionarRango('semana')"><strong>ÚLTIMA SEMANA</strong></button>
            </div>
            <div class="col-md-2">
              <button type="button" class="btn btn-outline-primary btn-sm w-100"
                (click)="seleccionarRango('mes')"><strong>MES</strong></button>
            </div>
            <div class="col-md-2">
              <button type="button" class="btn btn-outline-primary btn-sm w-100"
                (click)="seleccionarRango('trimestre')"><strong>TRIMESTRE</strong></button>
            </div>
            <div class="col-md-2">
              <button type="button" class="btn btn-outline-primary btn-sm w-100"
                (click)="seleccionarRango('semestre')"><strong>SEMESTRE</strong></button>
            </div>
            <div class="col-md-2">
              <button type="button" class="btn btn-outline-primary btn-sm w-100"
                (click)="seleccionarRango('anio')"><strong>AÑO</strong></button>
            </div>

          </div>
        </div>
      </div>




    </form>
    <div class="d-flex justify-content-center gap-3 mt-3">
      <button class="btn btn-primary d-flex align-items-center" type="button" (click)="buscarMantenimientos()"
        [disabled]="cargando">
        <span *ngIf="cargando" class="spinner-border spinner-border-sm me-2" role="status"></span>
        {{ cargando ? 'CONSULTANDO...' : 'CONSULTAR' }}
      </button>
    </div>

  </div>
</div>

<div class="card mt-3" *ngIf="cargando">
  <div class="card-body text-center py-4">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Consultando mantenimientos...</span>
    </div>
    <p class="mb-0 mt-2 text-secondary">Consultando mantenimientos...</p>
  </div>
</div>

<div class="card" *ngIf="mostrarTabla && !cargando">
  <div class="card-header bg-primary">
    <h5 class=" text-white"><strong>LISTADO DE MANTENIMIENTOS</strong></h5>
  </div>

  <div class="card-body custom-datatable noscroll">
    <div class="row mb-12">
      <div class="col-3 ms-auto">
        <div class="input-group">
          <input type="text" class="form-control" placeholder="Buscar....." [(ngModel)]="searchText"
            (input)="filterData()" />
          <span class="input-group-text">
            <i class="fa fa-search"></i> <!-- Icono de búsqueda -->
          </span>
        </div>
      </div>
    </div>


 <div class="custom-datatable table-responsive my-4">

  <table
    class="table table-mantenimiento align-middle mb-0 align-middle"
    id="tblMantenimiento">

    <thead class="bg-primary">
      <tr>
        <th class="text-center">FECHA</th>
        <th class="text-center">PLACA</th>
        <th class="text-center">KM</th>
        <th class="text-center">TIPO DE MANTENIMIENTO</th>
        <th class="text-center">TALLER</th>
        <th class="text-center">SERVICIOS</th>
        <th class="text-center">ACCIÓN</th>
        <th class="text-center">N.º FACTURA</th>
        <th class="text-center">VR</th>
        <th class="text-center">FORMA DE PAGO</th>
        <th class="text-center">OPCIONES</th>
      </tr>
    </thead>

    <tbody>

      <tr
        *ngFor="
          let mantenimiento of filteredTableItems
            | paginate: {
                itemsPerPage: pageSize1,
                currentPage: page1
              }
        ">

        <!-- FECHA -->
        <td class="text-center">
          {{ mantenimiento.fecha | date:'dd/MM/yyyy' }}
        </td>

        <!-- PLACA -->
        <td class="text-center">
          <strong>{{ mantenimiento.placa }}</strong>
        </td>

        <!-- KM -->
        <td class="text-center">
          {{ mantenimiento.km | number:'1.0-0' }}
        </td>

        <!-- TIPO DE MANTENIMIENTO -->
      <td class="text-center">
        <span class="badge" [ngClass]="getBadgeTipoMantenimiento(mantenimiento.tipoMantenimiento?.nombre)">
          {{ mantenimiento.tipoMantenimiento?.nombre | uppercase }}
        </span>
      </td>

        <!-- TALLER -->
        <td>
          {{ mantenimiento.taller }}
        </td>

        <!-- SERVICIO -->
        <td>
          {{ mantenimiento.tipoServicio?.tipo_de_mantenimiento | uppercase }}
        </td>

        <!-- ACCIÓN -->
        <td>
          {{ mantenimiento.tipoAccion?.descripcion }}
        </td>

        <!-- FACTURA -->
        <td class="text-center">
          {{ mantenimiento.factura || '—' }}
        </td>

        <!-- VALOR -->
        <td class="text-end">
          {{ mantenimiento.vrpagos | currency:'COP':'symbol-narrow':'1.0-0' }}
        </td>

        <!-- FORMA DE PAGO -->
        <td>
          {{ mantenimiento.formaPago?.descripcion || '—' }}
        </td>

        <!-- OPCIONES -->
        <td class="text-center">

          <div class="action">

            <ul class="list-inline mb-0">

              <!-- EDITAR -->
              <li class="edit list-inline-item">
                <button
                  type="button"
                  class="btn btn-link p-0"
                  (click)="
                    openModalMantenimiento(
                      myModal2,
                      mantenimiento.id
                    )
                  "
                  ngbTooltip="Editar">

                  <i class="icon-pencil-alt"></i>

                </button>
              </li>

              <!-- INACTIVAR -->
              <li class="delete list-inline-item">
                <button
                  type="button"
                  class="btn btn-link p-0"
                  (click)="
                    actualizarEstadoAInactivo(
                      mantenimiento.id
                    )
                  "
                  ngbTooltip="Inactivar">

                  <i class="icon-trash"></i>

                </button>
              </li>

            </ul>

          </div>

        </td>

      </tr>

      <!-- SIN RESULTADOS -->
      <tr *ngIf="!filteredTableItems?.length">

        <td
          class="text-center text-warning"
          colspan="10">

          {{ mensajeBusqueda ||
             'No se encontraron resultados con los filtros proporcionados.'
          }}

        </td>

      </tr>

    </tbody>

  </table>

</div>
    <div class="d-flex justify-content-between align-items-center mt-4">
      <!-- Selector de registros por página alineado a la izquierda -->
      <div class="d-flex align-items-center">
        <label for="pageSize1" class="me-2">Mostrar:</label>
        <select id="pageSize1" class="form-select w-auto" [(ngModel)]="pageSize1" (change)="page1 = 1">
          <option *ngFor="let size1 of [5, 10, 20, 50, 100]" [value]="size1">{{ size1 }}</option>
        </select>
        <span class="ms-2">registros por página</span>
      </div>

      <div class="mx-auto text-center">
        <span class="badge bg-primary ms-1"><b><span>Total registros: </span>{{ filteredTableItems?.length || 0
            }}</b></span>

      </div>

      <!-- Paginador alineado a la derecha -->
      <div class="text-end paginador-personalizado">
        <pagination-controls (pageChange)="page1 = $event" [maxSize]="5" [directionLinks]="true" [autoHide]="true"
          previousLabel="Anterior" nextLabel="Siguiente">
        </pagination-controls>
      </div>
    </div>

    
    <div class="card-body">
      <div class="btn-showcase text-center">
        <button class="btn btn-outline-success-2x" type="button" placement="top" ngbTooltip="Exportar a Excel"
          (click)="exportarExcel('tblMantenimiento', 'Listado_Mantenimiento')">
          <i class="icofont icofont-file-excel"></i> EXCEL
        </button>

        <button class="btn btn-outline-danger-2x" type="button" placement="top" ngbTooltip="Exportar a PDF" (click)="
            exportToPDF(
              'tblMantenimiento',
              'Listado_Mantenimiento',
              'Listado de Mantenimiento'
            )
          ">
          <i class="icofont icofont-file-pdf"></i> PDF
        </button>

        <button class="btn btn-primary" type="button" placement="top" ngbTooltip="Ficha de Mantenimientos"
          (click)="generarPDFMantenimientos( this.resultadoCompleto)">
          <i class="icofont icofont-file-pdf"></i> FICHA DE MANTENIMIENTOS
        </button>

      </div>
    </div>
    <!-- ===================================================== -->
<!-- RESUMEN DE MANTENIMIENTOS -->
<!-- ===================================================== -->


  </div>
</div>

 <div class="row g-4 mb-4"  *ngIf="mostrarTabla && !cargando">

  <!-- TOTAL MANTENIMIENTOS -->
  <div class="col-12 col-sm-6 col-xl-3">
    <div class="card maintenance-stat-card h-100 border-0">
      <div class="card-body">

        <div class="d-flex justify-content-between align-items-center">

          <div>
            <p class="stats-title">
              TOTAL MANTENIMIENTOS
            </p>

            <h2 class="stats-number">
              {{ estadisticasMantenimientos.cantidadMantenimientos }}
            </h2>

            <span class="stats-description">
              Registros realizados
            </span>
          </div>

          <div class="stats-icon bg-primary-subtle">
            <i class="icofont icofont-tools text-primary"></i>
          </div>

        </div>

      </div>
    </div>
  </div>


  <!-- COSTO TOTAL -->
  <div class="col-12 col-sm-6 col-xl-3">
    <div class="card maintenance-stat-card h-100 border-0">
      <div class="card-body">

        <div class="d-flex justify-content-between align-items-center">

          <div>
            <p class="stats-title">
              COSTO TOTAL
            </p>

            <h2 class="stats-number">
              {{ estadisticasMantenimientos.costoTotal
                | currency:'COP':'symbol-narrow':'1.0-0' }}
            </h2>

            <span class="stats-description">
              Valor de mantenimientos
            </span>
          </div>

          <div class="stats-icon bg-success-subtle">
            <i class="icofont icofont-money text-success"></i>
          </div>

        </div>

      </div>
    </div>
  </div>


  <!-- COSTO PROMEDIO -->
  <div class="col-12 col-sm-6 col-xl-3">
    <div class="card maintenance-stat-card h-100 border-0">
      <div class="card-body">

        <div class="d-flex justify-content-between align-items-center">

          <div>
            <p class="stats-title">
              COSTO PROMEDIO
            </p>

            <h2 class="stats-number">
              {{ estadisticasMantenimientos.costoPromedio
                | currency:'COP':'symbol-narrow':'1.0-0' }}
            </h2>

            <span class="stats-description">
              Por mantenimiento
            </span>
          </div>

          <div class="stats-icon bg-warning-subtle">
            <i class="icofont icofont-chart-bar-graph text-warning"></i>
          </div>

        </div>

      </div>
    </div>
  </div>


  <!-- VEHÍCULOS -->
  <div class="col-12 col-sm-6 col-xl-3">
    <div class="card maintenance-stat-card h-100 border-0">
      <div class="card-body">

        <div class="d-flex justify-content-between align-items-center">

          <div>
            <p class="stats-title">
              VEHÍCULOS ATENDIDOS
            </p>

            <h2 class="stats-number">
             {{ estadisticasMantenimientos.cantidadVehiculos }}
            </h2>

            <span class="stats-description">
              Vehículos con mantenimiento
            </span>
          </div>

          <div class="stats-icon bg-info-subtle">
            <i class="icofont icofont-car-alt-1 text-info"></i>
          </div>

        </div>

      </div>
    </div>
  </div>

</div>


<ng-template #myModal2 let-modal>
  <div class="card">
    <div class="card-header d-flex align-items-center bg-primary text-white">
      <i class="icofont icofont-verification-check me-2"></i>
      <h5 class="mb-0"><strong>Registro de mantenimientos</strong></h5>
    </div>

    <div class="card-body">
      <form [formGroup]="formMantenimiento">
        <div class="row g-3 mb-3">
          <div class="col-md-3">
            <label class="form-label" for="finicial"><strong>Fecha de realización</strong> *:</label>
            <div class="input-group input-group-sm">
              <input #inputFecha id="finicial" formControlName="fecha" type="date"
                class="form-control form-control-lg fs-14" name="fecha" />
            </div>
          </div>

          <div class="col-md-3">
            <label class="form-label" for="vehiculos"><strong>Placa</strong> *:</label>
            <ng-select #inputPlaca id="vehiculos" formControlName="placa" [items]="vehiculos" bindLabel="placa"
              bindValue="placa" placeholder="Selecciona una opción" class="js-example-placeholder-multiple">
            </ng-select>
          </div>

          <div class="col-md-3">
            <label class="form-label" for="ffinal"><strong>Kilometraje</strong> *:</label>
            <input #inputKm id="finicial" formControlName="km" type="text" name="" class="form-control"
              placeholder="Ingrese el kilometraje actual" />
          </div>

          <div class="col-md-3">
            <label class="form-label" for="objeto"><strong>Tipo de mantenimiento</strong> *:</label>
            <ng-select #inputtipo id="objeto" formControlName="tipo" [items]="TipoMantenimiento" bindLabel="nombre"
              bindValue="id" placeholder="Selecciona una opción" class="js-example-placeholder-multiple">
            </ng-select>
          </div>

          <div class="col-md-3">
            <label class="form-label" for="viaje"><strong>Proveedor o taller mecanico</strong> *:</label>
            <ng-select #inputTaller placeholder="Selecciona una opción" formControlName="taller" [items]="empresaTaller"
              bindLabel="nombre" bindValue="nombre" class="js-example-placeholder-multiple">
            </ng-select>
          </div>

          <div class="col-md-3">
            <label class="form-label"><strong>Conductor</strong> *:</label>
            <ng-select #inputConductor formControlName="conductor" [items]="conductor" bindValue="cedula"
              [bindLabel]="'cedula'" placeholder="Selecciona una opción" class="js-example-placeholder-multiple">
              <ng-template ng-label-tmp let-item="item">
                <span class="text-uppercase">
                  {{ item.cedula }} - {{ item.primernombre }} {{ item.segundonombre }} {{ item.papellidos }} {{
                  item.seapellidos }}
                </span>
              </ng-template>

              <ng-template ng-option-tmp let-item="item">
                <span class="text-uppercase">
                  {{ item.cedula }} - {{ item.primernombre }} {{ item.segundonombre }} {{ item.papellidos }} {{
                  item.seapellidos }}
                </span>
              </ng-template>

            </ng-select>
          </div>

          <div class="col-md-3">
            <label class="form-label"><strong>Número de factura</strong> *:</label>
            <input #inputFactura class="form-control" formControlName="factura" type="factura"
              placeholder="Ingrese el número de factura" />
          </div>

          <div class="col-md-3">
            <label class="form-label"><strong>Forma de pago</strong> *:</label>
            <ng-select #inputForma placeholder="Selecciona una opción" formControlName="forma" [items]="formapago"
              bindLabel="descripcion" bindValue="id">
            </ng-select>
          </div>

          <div class="col-md-3">
            <label class="form-label"><strong>Tipo de acción</strong> *:</label>
            <ng-select #inputAccion [items]="tipoaccion" bindLabel="descripcion" formControlName="accion"
              bindValue="id" placeholder="Selecciona una opción">
            </ng-select>
          </div>
          <div class="col-md-3">
            <label class="form-label"><strong>Valor pagado</strong> *:</label>
            <input #inputVrPagos class="form-control" type="number" formControlName="vrpagos" [value]="valorFormateado"
              (input)="formatearYGuardarValor($event)" placeholder="Ingrese el valor pagado" />
          </div>



          <div class="col-md-6">
            <label class="form-label"><strong>Servicio realizado</strong> *:</label>
            <div class="input-group">
              <div class="form-control p-0 border-0">
                <ng-select #inputServicio [items]="servicioRealizado" formControlName="servicio"
                  bindLabel="tipo_de_mantenimiento" bindValue="id"
                  placeholder="Selecciona una opción" class="js-example-placeholder-multiple">
                  <!-- Texto cuando ya fue seleccionado -->
                  <!-- Texto cuando ya fue seleccionado -->
                  <ng-template ng-label-tmp let-item="item">
                    {{ item?.tipo_de_mantenimiento ? item.tipo_de_mantenimiento.toUpperCase() : '' }}
                  </ng-template>

                  <!-- Texto en la lista desplegable -->
                  <ng-template ng-option-tmp let-item="item">
                    {{ item?.tipo_de_mantenimiento ? item.tipo_de_mantenimiento.toUpperCase() : '' }}
                  </ng-template>

                </ng-select>
              </div>

              <button type="button" class="btn btn-primary btn-sm" ngbTooltip="Crear Servicio"
                (click)="openModalServicioRealizado(myModal)">
                <i class="icofont icofont-plus"></i>
              </button>
            </div>
          </div>

          <div class="col-md-12">
            <label><strong>Observaciones:</strong></label>
            <textarea class="form-control" id="observaciones" rows="3" formControlName="observacion"></textarea>
          </div>
        </div>
      </form>
      <div class="modal-footer">
        <button class="btn btn-primary" (click)="guardarMantenimiento()">
          Guardar
        </button>
        <button class="btn btn-secondary" (click)="modal.dismiss()">
          Cancelar
        </button>
      </div>
    </div>
  </div>
</ng-template>


<ng-template #myModal let-modal>
  <div class="card border-4 rounded-3">
    <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center rounded-top">
      <h5 class="mb-0"><strong>AGREGAR TIPOS DE MANTENIMIENTOS</strong></h5>
    </div>
    <div class="modal-body">
      <form [formGroup]="formServicio">
        <div class="row g-3 mb-3">
          <div class="col-md-3">
            <label><strong>Sistema</strong> *:</label>
            <ng-select [items]="sistemaMantenimiento" formControlName="sistema" bindLabel="descripcion"
              bindValue="descripcion" placeholder="Selecciona una opción" class="js-example-placeholder-multiple">
            </ng-select>
          </div>
          <div class="col-md-3">
            <label><strong>Parte</strong> *:</label>
            <ng-select [items]="parteMantenimiento" formControlName="parte" bindLabel="descripcion"
              bindValue="descripcion" placeholder="Selecciona una opción" class="js-example-placeholder-multiple">
            </ng-select>
          </div>
          <div class="col-md-3">
            <label><strong>Tipo de Mantenimiento</strong> *:</label>
            <input type="text" class="form-control" formControlName="tipo_de_mantenimiento" #inputTipo />
          </div>

        </div>
      </form>

    </div>

    <div class="modal-footer">
      <button class="btn btn-primary" (click)="guardarServicio(modal)">
        Guardar
      </button>
      <button class="btn btn-secondary" (click)="modal.dismiss()">
        Cancelar
      </button>
    </div>
  </div>
</ng-template>

<div class="toast-container position-fixed bottom-0 end-0 p-3" style="z-index: 1055" aria-live="polite"
  aria-atomic="true">
  <div *ngIf="mostrandoToast" class="toast fade show align-items-center text-white border-0"
    [ngClass]="toastTipo === 'success' ? 'bg-success' : (toastTipo === 'error' ? 'bg-danger' : 'bg-primary')"
    role="alert" aria-live="assertive" aria-atomic="true">
    <div class="d-flex">
      <div class="toast-body d-flex align-items-center">
        <div *ngIf="toastTipo === 'cargando'" class="spinner-border spinner-border-sm me-2" role="status"></div>
        <i *ngIf="toastTipo === 'success'" class="icofont icofont-check-circled me-2"></i>
        <i *ngIf="toastTipo === 'error'" class="icofont icofont-close-circled me-2"></i>
        {{ mensajeToast }}
      </div>
      <button type="button" class="btn-close btn-close-white me-2 m-auto" (click)="mostrandoToast = false"
        aria-label="Cerrar"></button>
    </div>
  </div>
</div>